import { forwardRef } from 'react';

interface SectionLayoutProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
}
export const SectionLayout = forwardRef<HTMLDivElement, SectionLayoutProps>(
  ({ title, description, children }, ref) => {
    return (
      <div className="flex flex-col gap-5" ref={ref}>
        <div className="flex flex-col gap-3">
          {title != null && (
            <div className="text-text300 font-poppins text-base font-[600] md:text-xl">
              {title}
            </div>
          )}
          {description != null && (
            <div className="font-poppins text-text600 w-[90%] text-xs font-normal leading-[18px] md:w-full">
              {description}
            </div>
          )}
        </div>
        {children != null && <div>{children}</div>}
      </div>
    );
  }
);

SectionLayout.displayName = 'SectionLayout';
